export const cityList = [
  { code: '440000', value: '全省', center: [113.280637, 23.125178] },
  { code: '440100', value: '广州市' },
  { code: '440300', value: '深圳市' },
  { code: '440400', value: '珠海市' },
  { code: '440500', value: '汕头市' },
  { code: '440600', value: '佛山市' },
  { code: '440200', value: '韶关市' },
  { code: '441600', value: '河源市' },
  { code: '441400', value: '梅州市' },
  { code: '441300', value: '惠州市' },
  { code: '441500', value: '汕尾市' },
  { code: '441900', value: '东莞市' },
  { code: '442000', value: '中山市' },
  { code: '440700', value: '江门市' },
  { code: '441700', value: '阳江市' },
  { code: '440800', value: '湛江市' },
  { code: '440900', value: '茂名市' },
  { code: '441200', value: '肇庆市' },
  { code: '441800', value: '清远市' },
  { code: '445100', value: '潮州市' },
  { code: '445200', value: '揭阳市' },
  { code: '445300', value: '云浮市' }
]
